// PROFILE
export const PROFILE_LOADED    = "PROFILE_LOADED";
export const PROFILE_UPDATED   = "PROFILE_UPDATED";
export const PROFILE_LOADING   = "PROFILE_LOADING";
export const PROFILE_ERROR     = "PROFILE_ERROR";

// CONFIG
export const CONFIG_LOADED = "CONFIG_LOADED";

// COMMON
export const GET_ERRORS      = "GET_ERRORS";
export const CREATE_MESSAGE  = "CREATE_MESSAGE";

// AUTHENTICATION
export const USER_LOADING            = "USER_LOADING";
export const USER_LOADED             = "USER_LOADED";
export const AUTH_ERROR              = "AUTH_ERROR";
export const LOGIN_SUCCESS           = "LOGIN_SUCCESS";
export const LOGIN_FAIL              = "LOGIN_FAIL";
export const LOGOUT_SUCCESS          = "LOGOUT_SUCCESS";
export const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS";
export const PASSWORD_CHANGE_FAIL    = "PASSWORD_CHANGE_FAIL";
export const IS_PASSWORD_CHANGED     = "IS_PASSWORD_CHANGED";

// THREATS WATCHER
export const GET_LEADS               = "GET_LEADS";
export const DELETE_LEAD             = "DELETE_LEAD";

export const GET_SOURCES             = "GET_SOURCES";
export const ADD_SOURCE              = "ADD_SOURCE";
export const DELETE_SOURCE           = "DELETE_SOURCE";
export const PATCH_SOURCE            = "PATCH_SOURCE";

export const GET_KEYWORDS            = "GET_KEYWORDS";
export const ADD_KEYWORD             = "ADD_KEYWORD";
export const DELETE_KEYWORD          = "DELETE_KEYWORD";
export const PATCH_KEYWORD           = "PATCH_KEYWORD";

export const GET_BANNED_WORDS        = "GET_BANNED_WORDS";
export const ADD_BANNED_WORD         = "ADD_BANNED_WORD";
export const DELETE_BANNED_WORD      = "DELETE_BANNED_WORD";
export const PATCH_BANNED_WORD       = "PATCH_BANNED_WORD";

export const GET_MONITORED_KEYWORDS   = "GET_MONITORED_KEYWORDS";
export const ADD_MONITORED_KEYWORD    = "ADD_MONITORED_KEYWORD";
export const DELETE_MONITORED_KEYWORD = "DELETE_MONITORED_KEYWORD";
export const PATCH_MONITORED_KEYWORD  = "PATCH_MONITORED_KEYWORD";

export const GET_WEEKLY_SUMMARY      = "GET_WEEKLY_SUMMARY";
export const GET_BREAKING_NEWS       = "GET_BREAKING_NEWS";
export const GET_WORD_SUMMARY        = "GET_WORD_SUMMARY";
export const GENERATE_WORD_SUMMARY   = "GENERATE_WORD_SUMMARY";

export const WORLDMAP_GET_SOURCES    = "WORLDMAP_GET_SOURCES";
export const WORLDMAP_PATCH_SOURCE   = "WORLDMAP_PATCH_SOURCE";

export const GET_THREATS_WATCHER_STATISTICS = "GET_THREATS_WATCHER_STATISTICS";

// DATA LEAK
export const DATALEAK_GET_KEYWORDS   = "DATALEAK_GET_KEYWORDS";
export const DATALEAK_ADD_KEYWORD    = "DATALEAK_ADD_KEYWORD";
export const DATALEAK_DELETE_KEYWORD = "DATALEAK_DELETE_KEYWORD";
export const DATALEAK_PATCH_KEYWORD  = "DATALEAK_PATCH_KEYWORD";

export const DATALEAK_GET_ALERTS     = "DATALEAK_GET_ALERTS";
export const DATALEAK_UPDATE_ALERT   = "DATALEAK_UPDATE_ALERT";

export const GET_DATA_LEAK_STATISTICS = "GET_DATA_LEAK_STATISTICS";

// SITE MONITORING
export const GET_SITES               = "GET_SITES";
export const ADD_SITE                = "ADD_SITE";
export const DELETE_SITE             = "DELETE_SITE";
export const PATCH_SITE              = "PATCH_SITE";

export const GET_SITE_ALERTS         = "GET_SITE_ALERTS";
export const UPDATE_SITE_ALERT       = "UPDATE_SITE_ALERT";

export const EXPORT_MISP             = "EXPORT_MISP";
export const EXPORT_TO_MISP          = "EXPORT_TO_MISP";

export const GET_SITE_STATISTICS     = "GET_SITE_STATISTICS";

// DNS FINDER
export const GET_DNS_MONITORED        = "GET_DNS_MONITORED";
export const ADD_DNS_MONITORED        = "ADD_DNS_MONITORED";
export const DELETE_DNS_MONITORED     = "DELETE_DNS_MONITORED";
export const PATCH_DNS_MONITORED      = "PATCH_DNS_MONITORED";

export const GET_KEYWORD_MONITORED    = "GET_KEYWORD_MONITORED";
export const ADD_KEYWORD_MONITORED    = "ADD_KEYWORD_MONITORED";
export const DELETE_KEYWORD_MONITORED = "DELETE_KEYWORD_MONITORED";
export const PATCH_KEYWORD_MONITORED  = "PATCH_KEYWORD_MONITORED";

export const DNS_GET_ALERTS          = "DNS_GET_ALERTS";
export const ADD_ALERT               = "ADD_ALERT";
export const DELETE_ALERT            = "DELETE_ALERT";
export const UPDATE_ALERT            = "UPDATE_ALERT";
export const UPDATE_ALERT_STATUS     = "UPDATE_ALERT_STATUS";

export const GET_DNS_FINDER_STATISTICS = "GET_DNS_FINDER_STATISTICS";

// LEGITIMATE DOMAINS
export const GET_LEGITIMATE_DOMAINS      = "GET_LEGITIMATE_DOMAINS";
export const ADD_LEGITIMATE_DOMAIN       = "ADD_LEGITIMATE_DOMAIN";
export const DELETE_LEGITIMATE_DOMAIN    = "DELETE_LEGITIMATE_DOMAIN";
export const PATCH_LEGITIMATE_DOMAIN     = "PATCH_LEGITIMATE_DOMAIN";
export const EXPORT_LEGITIMATE_DOMAIN_TO_MISP = "EXPORT_LEGITIMATE_DOMAIN_TO_MISP";
export const RESET_EXPORT_LOADING        = "RESET_EXPORT_LOADING";

export const GET_LEGITIMATE_DOMAIN_STATISTICS = "GET_LEGITIMATE_DOMAIN_STATISTICS";

// CYBER WATCH
export const CYBERWATCH_GET_CVES             = "CYBERWATCH_GET_CVES";
export const CYBERWATCH_ARCHIVE_CVE          = "CYBERWATCH_ARCHIVE_CVE";
export const CYBERWATCH_UNARCHIVE_CVE        = "CYBERWATCH_UNARCHIVE_CVE";
export const CYBERWATCH_GET_ARCHIVED_CVES    = "CYBERWATCH_GET_ARCHIVED_CVES";

export const CYBERWATCH_GET_RANSOMWARE_VICTIMS  = "CYBERWATCH_GET_RANSOMWARE_VICTIMS";
export const CYBERWATCH_ARCHIVE_VICTIM          = "CYBERWATCH_ARCHIVE_VICTIM";
export const CYBERWATCH_UNARCHIVE_VICTIM        = "CYBERWATCH_UNARCHIVE_VICTIM";
export const CYBERWATCH_GET_ARCHIVED_VICTIMS    = "CYBERWATCH_GET_ARCHIVED_VICTIMS";

export const CYBERWATCH_GET_WATCH_RULES      = "CYBERWATCH_GET_WATCH_RULES";
export const CYBERWATCH_ADD_WATCH_RULE       = "CYBERWATCH_ADD_WATCH_RULE";
export const CYBERWATCH_DELETE_WATCH_RULE    = "CYBERWATCH_DELETE_WATCH_RULE";
export const CYBERWATCH_PATCH_WATCH_RULE     = "CYBERWATCH_PATCH_WATCH_RULE";

export const CYBERWATCH_GET_WATCH_RULE_HITS  = "CYBERWATCH_GET_WATCH_RULE_HITS";
export const CYBERWATCH_ARCHIVE_HIT          = "CYBERWATCH_ARCHIVE_HIT";
export const CYBERWATCH_UNARCHIVE_HIT        = "CYBERWATCH_UNARCHIVE_HIT";
export const CYBERWATCH_GET_ARCHIVED_HITS    = "CYBERWATCH_GET_ARCHIVED_HITS";

// ── Stats "load-all-at-once" action types ───────────────────────────────────
// These are dispatched exclusively by the getAll* actions used in *Stats views.
// They store data in separate reducer keys so they never clash with paginated
// table state.
export const GET_SITES_ALL               = "GET_SITES_ALL";
export const GET_SITE_ALERTS_ALL         = "GET_SITE_ALERTS_ALL";
export const DNS_GET_ALERTS_ALL          = "DNS_GET_ALERTS_ALL";
export const GET_DNS_MONITORED_ALL       = "GET_DNS_MONITORED_ALL";
export const GET_KEYWORD_MONITORED_ALL   = "GET_KEYWORD_MONITORED_ALL";
export const DATALEAK_GET_ALERTS_ALL     = "DATALEAK_GET_ALERTS_ALL";
export const DATALEAK_GET_KEYWORDS_ALL   = "DATALEAK_GET_KEYWORDS_ALL";
export const GET_LEGITIMATE_DOMAINS_ALL  = "GET_LEGITIMATE_DOMAINS_ALL";
